<template>
    <div class="w-100 dropoff">
        <div class="row py-2 mx-5">
            <div class="col-12">
                <form @submit.prevent="validateTracking()">
                    <div class="row">
                        <div :class="{ 'col-9': !isTracking.queryId, 'col-12': isTracking.queryId }">
                            <h6 class="heading-small text-muted">กรอกหมายเลขพัสดุ</h6>
                            <input 
                                ref="searchTracking"
                                type="text"
                                class="form-control m-1"
                                :class="{ 'has-error': isError.errorMsg }"
                                :placeholder="isPlaceholder"
                                @change="clearError($event)"
                                v-on:keyup="clearError($event)"
                                v-model="isTracking.trackingCode"
                            />
                        </div>
                        <div class="col-3 d-flex align-items-end justify-content-center" v-if="!isTracking.queryId">
                            <b-button type="submit" block variant="primary" class="m-1" :disabled="isTracking.trackingCode.length < 11 || isLoading">
                                <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i>
                                นำเข้า
                            </b-button>
                        </div>
                        <div class="col-12 text-center text-danger mb-3" v-if="isError.errorMsg">
                            {{ isError.errorMsg }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-2">
                            <label floater>
                                น้ำหนัก {{ $THEME.unitKG ? '(กิโลกรัม)' : '(กรัม)' }} <small class="text-danger">*</small>
                            </label>
                            <input 
                                step="0.01"
                                type="number"
                                placeholder="น้ำหนัก"
                                class="form-control"
                                ref="focusWeight"
                                :disabled="disableInputSize() || isTracking.action.photo"
                                v-model="isTracking.parcel.weight"
                                @keyup="checkWeight()"
                                @blur="checkWeight()"
                                :onkeydown="$THEME.unitKG ? 'return event.keyCode !== 69 && event.keyCode !== 189' : 'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                            />
                            <small v-if="validateWeight.checkWeight.status" class="text-danger">
                                {{ validateWeight.checkWeight.msg }}
                            </small>
                        </div>
                        <div class="col">
                            <AutoBox 
                                :listSize="listSize"
                                :size="isTracking.size"
                                :weight.sync="isTracking.parcel.weight"
                                :weightKG.sync="isTracking.parcel.weightKG"
                                :width.sync="isTracking.parcel.width"
                                :length.sync="isTracking.parcel.length"
                                :height.sync="isTracking.parcel.height"
                                :keyBox.sync="isTracking.parcel.keyBox"
                                :favoriteDimension="disableInputSize() || isTracking.action.photo"
                                courier_key="FLEDS"
                            />
                        </div>
                        <div class="col">
                            <Dimension 
                                ref="dimensionParcel"
                                :dimension="isTracking.parcel"
                                courierCode="FLEDS"
                                :favoriteDimension="disableInputSize() || isTracking.action.photo"
                                :showLock="false"
                            />
                        </div>
                    </div>
                    <div class="row" v-if="(isTracking.queryId && isTracking.action.photo)">
                        <div class="col">
                            <div class="input-group mb-3 d-flex justify-content-center">
                                <b-form-file type="file" id="dropoff-image" style="position: relative; width:100%; height: 100%; opacity: 0;border:1px solid red;"
                                accept=".jpg, .png"
                                    placeholder="เลือกรูปภาพ"
                                    :disabled="!isTracking.action.photo"
                                    @change="readImage($event)" 
                                    @drop.prevent="readImage($event)"
                                    drop-placeholder="Drop file here..."
                                    v-model="isTracking.images"/>
                                <label 
                                    class="input-group-text text-center d-flex flex-column justify-content-center align-items-center" for="dropoff-image" 
                                    style="border:dashed 2px #ccc; border-radius: 10px; max-height:300px; max-width: 300px; min-height: 200px; min-width: 300px; cursor: pointer;" >
                                    <div class="row" v-if="!isTracking.images.length">
                                        <i class="fa fa-plus"></i>
                                    </div>
                                    <div class="row pt-1" v-if="!isTracking.images.length">
                                        เลือกรูปภาพ
                                    </div>
                                    <template v-for="(image, index) in isTracking.images">
                                        <template>
                                            <div :key="index">
                                                <img :src="image.preview" alt="image" style="max-height:300px;">
                                            </div>
                                        </template>
                                    </template>
                                </label>
                            </div>
                            <!-- <div class="form-group">
                                <label for="dropoff-image">
                                    รูปภาพ <span class="text-danger">*</span>
                                </label>
                                <b-form-file
                                    accept=".jpg, .png"
                                    placeholder="เลือกรูปภาพ"
                                    :disabled="!isTracking.action.photo"
                                    @change="readImage($event)"
                                    v-model="isTracking.images"
                                >
                                <template slot="file">
                                    <div class="preview-image">
                                        Select a File ..
                                    </div>
                                </template>
                                </b-form-file>
                            </div> -->
                            <!-- <div class="d-flex">
                                <template v-for="(image, index) in isTracking.images">
                                    <template>
                                        <div :key="index" class="pr-5">
                                            <img class="preview-image" :src="image.preview" alt="image" width="150" height="150">
                                        </div>
                                    </template>
                                </template>
                            </div> -->
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center" v-if="isTracking.queryId">
                        <b-button type="submit" block variant="primary" class="m-1 col-5" :disabled="isTracking.trackingCode.length < 11 || isLoading">
                                <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i>
                                นำเข้า
                            </b-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import AutoBox from '@/components/AutoBox';
    import { checkWeightRules } from "@/plugins/weightParcel.js"
    import Dimension from '@/components/custom/pos/Dimension';
    import setLocalStorage from '@/constants/LocalStorageManagement'
    
    import { required } from "vuelidate/lib/validators"
    import Compressor from 'compressorjs'

    export default {
        name: 'scanTrackingFlashDropoff',
        props: {
            isPlaceholder: String,
            isError: Object,
            isTracking: Object,
            listSize: Object,
            isLoading: Boolean,
            courierCode: String,
            shopId: [Number, String]
        },
        data() {
            return {
                validateWeight: {
                    checkWeight: {
                        status: false,
                        msg: ''
                    }
                }
            }
        },
        components: {
            AutoBox,
            Dimension
        },
        methods: {
            disableInputSize () {
                return (!this.isTracking.trackingCode || !this.isTracking.queryId) && !(this.isTracking.action.weight || this.isTracking.action.dim || this.isTracking.action.photo);
            },
            validateTracking() {
                if (this.isTracking.trackingCode.length < 11 || this.isLoading) {
                    return false
                }

                this.$emit('checkTracking')
            },
            clearError(event) {
                this.isError.errorMsg = false
                this.isTracking.queryId = '';
                this.isTracking.images = [];
                this.isTracking.parcel = {
                    width: '',
                    length: '',
                    height: '',
                    weight: '',
                    weightKG: ''
                };
                this.isTracking.size = {
                    boxSize: ''
                };
                this.isTracking.action = {
                    photo: false,
                    dim: false,
                    weight: false
                }
                if (this.isTracking.trackingCode.length > 5) {
                    this.$emit('checkTrackingRegx', event)
                }
            },
            checkWeight() {
                const { status, msg } = checkWeightRules(this.courierCode, this.isTracking.parcel.weight)

                this.validateWeight.checkWeight.status = status
                this.validateWeight.checkWeight.msg = msg
            },
            readImage() {
                console.log('select ja', this.isTracking.images)
                if (event.target.files.length < 1) return false

                let SELF = this

                let temp = []

                Array.from(event.target.files).forEach((image) => {
                    new Compressor(image, {
                        quality: 0.6,
                        maxHeight: 1024,
                        success(result) {
                            const reader = new FileReader();
                            reader.readAsDataURL(result)
                            reader.onloadend = e => {
                                temp.push({ preview: e.target.result, url: '' })
                                SELF.isTracking.images = temp
                            }
                        }
                    })
                })
            }
        }
    }
</script>